import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/navbar";
import Section1 from "./components/section1";
import YourRecentSearch from "./components/yourRecentSearch";
import TopDestination from "./components/yourDestination";
import ToursCatalogue from "./components/ToursCatalogue";
import AffordableGateways from "./components/AffordableGateways";
import OfferHotspot from "./components/offersHotspot";
import LoveVigovia from "./components/loveVigovia";
import UserNav from "./components/UserNav";
import TourSearchPage from "./pages/TourSearchPage";
import VisaMain from "./components/VisaMain";
import VisaInfo from "./components/VisaInfo";
import VisaApp from "./components/VisaApp";
import Profile from "./components/profile";
import Footer from "./components/Footer";
import TourDetails from "./components/TourDetails";
import BookingInfo from "./components/BookingInfo";
import Forex from "./components/forexlanding";
import ForexBooking from "./components/forexbooking";
import ForexOrderSummary from "./components/forexordersummary";
import TrackingPage from "./components/trackingPage";
import "./App.css";
import FinalCart from "./components/FinalCart";


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation(); // Now this is inside Router

  return (
    <>
      {/* Only show Navbar if not on /tours */}
      {location.pathname !== "/tours" && !location.pathname.startsWith("/tour-details") && location.pathname !== "/cart" 
      &&(
  <Navbar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
)}


      <Routes>
        <Route
          path="/"
          element={
            <>
              <Section1 />
              {isLoggedIn && <YourRecentSearch />}
              <TopDestination />
              <ToursCatalogue />
              <AffordableGateways />
              <OfferHotspot />
              <LoveVigovia />
              <Footer />
            </>
          }
        />
        <Route path="/user-profile" element={<UserNav />} />
        <Route path="/tours" element={<TourSearchPage />} />
        <Route path="/toursbooking" element={<BookingInfo />} />
        <Route path="/visa" element={<VisaMain />} />
        <Route path="/VisaInfo" element={<VisaInfo />} />
        <Route path="/VisaApp" element={<VisaApp />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/tour-details/:id" element={<TourDetails />} />
        <Route path="/forex" element={<Forex />} />
        <Route path="/forex-booking" element={<ForexBooking />} />
        <Route path="/forexordersummary" element={<ForexOrderSummary />} />
        <Route path="/tracking" element={<TrackingPage />} />
        <Route path="/cart" element={<FinalCart />} />
      </Routes>
    </>
  );
}

export default App;
